import React from 'react';
import styled from 'styled-components';

import Grid from '../grid/Grid';
import GridElement from '../grid/GridElement';
import TimeTable from './TimeTable';
import { days } from './timeUnits';
import { H3 } from 'partials/typography';

export const Calendar = props => {

    const { courses, options, selectedPeriod } = props;

    return (
        <Wrapper>
            <Grid>
                { days.map((day,idx) => {
                    return (
                        <DayGridElement
                            colStart="auto"
                            key={idx}
                        >
                            <H3>{day}</H3>
                        </DayGridElement>
                    )
                })}
            </Grid>
            <TimeTable 
                courses={courses} 
                options={options}
                selectedPeriod={selectedPeriod}
                handleCollision={props.handleCollision}
            />
            
        </Wrapper>
    )
}

export default Calendar;

const Wrapper = styled.section`
    padding-left: 20px; 
    @media(max-width: 1000px) {
        display: none; 
    }
`

const DayGridElement = styled(GridElement)`
    h3 {
        color: #fff;
        text-align: center;
    }
    padding: 16px 0 30px;
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/timetable/Calendar.js